module.exports = __webpack_public_path__ + "mobile hero dental.svg?0f669c8439cecd00d9e4d52cd3bd374c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/mobile hero dental.svg
// module id = 33
// module chunks = 0